// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppNavbar.css — Barra superior clara, estilo Login */

.an-bar {
  flex-shrink: 0;
  z-index: 1030;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-left: 14px;
  padding-right: 10px;
  padding-bottom: 8px;
  background: var(--sn-superficie);
  border-bottom: 1px solid var(--sn-borde);
}

.an-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.an-logo-img {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  object-fit: contain;
}

.an-brand-name {
  font-size: 14px;
  font-weight: 800;
  color: var(--sn-marca-fuerte);
  line-height: 1.1;
  letter-spacing: 0.3px;
}

.an-brand-sub {
  font-size: 9px;
  color: var(--sn-texto-3);
  font-weight: 500;
  letter-spacing: 1px;
}

.an-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.an-icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--sn-borde);
  background: var(--sn-superficie-2);
  color: var(--sn-marca);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.an-icon-btn:hover {
  background: var(--sn-superficie-3);
}

.an-icon-btn--menu::after {
  display: none;
}

.an-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.an-menu-item--danger {
  color: var(--sn-peligro);
}

.an-menu {
  max-height: 70vh;
  overflow-y: auto;
  min-width: 230px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppNavbar.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* AppNavbar.css — Barra superior clara, estilo Login */\n\n.an-bar {\n  flex-shrink: 0;\n  z-index: 1030;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding-left: 14px;\n  padding-right: 10px;\n  padding-bottom: 8px;\n  background: var(--sn-superficie);\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.an-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.an-logo-img {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  object-fit: contain;\n}\n\n.an-brand-name {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--sn-marca-fuerte);\n  line-height: 1.1;\n  letter-spacing: 0.3px;\n}\n\n.an-brand-sub {\n  font-size: 9px;\n  color: var(--sn-texto-3);\n  font-weight: 500;\n  letter-spacing: 1px;\n}\n\n.an-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.an-icon-btn {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  border: 1px solid var(--sn-borde);\n  background: var(--sn-superficie-2);\n  color: var(--sn-marca);\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.an-icon-btn:hover {\n  background: var(--sn-superficie-3);\n}\n\n.an-icon-btn--menu::after {\n  display: none;\n}\n\n.an-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.an-menu-item--danger {\n  color: var(--sn-peligro);\n}\n\n.an-menu {\n  max-height: 70vh;\n  overflow-y: auto;\n  min-width: 230px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
